import React from 'react';

// Dark total panel for single-category quotes: package total, included misc, grand total.
export const PackageTotalPanel = ({ packageTotal, misc, formatCurrency }) => (
  <div className="bg-navy text-white rounded-xl p-4 shadow-lg" data-testid="predefined-total-panel">
    <div className="flex justify-between items-center" data-testid="panel-package-total">
      <span className="font-semibold">Package Total</span>
      <span className="text-xl font-bold">{formatCurrency(packageTotal)}</span>
    </div>
    <MiscLines packageTotal={packageTotal} misc={misc} formatCurrency={formatCurrency} />
  </div>
);

// "+ Miscellaneous (included)" and "Grand Total incl. misc"; renders nothing without misc.
export const MiscLines = ({ packageTotal, misc, formatCurrency }) => (misc > 0 ? (
  <>
    <div className="flex justify-between text-white/70 mt-2" data-testid="panel-misc-line">
      <span>+ Miscellaneous (included)</span>
      <span>+ {formatCurrency(misc)}</span>
    </div>
    <div className="flex justify-between items-center pt-3 mt-3 border-t-2 border-white/30" data-testid="panel-grand-total-incl-misc">
      <span className="font-semibold">Grand Total incl. misc</span>
      <span className="text-2xl font-bold">{formatCurrency(packageTotal + misc)}</span>
    </div>
  </>
) : null);
